import React from 'react';

class Subtitle extends React.Component {
    render() {
        return (
            <div>
                <div className="subtitle" >
                    <p><i className={this.props.icon} ></i>
                        {this.props.target ? <a href={this.props.target} target="_blank"> {this.props.subtitle} </a> : this.props.subtitle}</p>
                </div>
            </div>
        )
    }
}

export default Subtitle;


// WEBPACK FOOTER //
// ./src/components/Subtitle.js